export enum Storages {
  TOKEN = 'token',
  QUEUE = 'queue',
}
